import { createDynamicSlice } from ".";
import { getPermissionListThunk } from "../thunks/permissionsThunk";

export const permissionsSlice = createDynamicSlice({
  name: "permissions",
  thunk: getPermissionListThunk,
  listMode: true,
  resetActionName: "resetPermissions",
});

export const permissionsReducer = permissionsSlice.reducer;
export const { resetPermissions } = permissionsSlice.actions;
